import { FC, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { getUserMedia } from '@public/workers/src/shared/utils/webApi/mediaDevices';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { ButtonIwText } from '@/_pages/interwill/components/ButtonIwText';
import { media } from '@/shared/components';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { AccessTutorialModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const AccessTutorialModal: FC<AccessTutorialModalProps> = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'accessTutorial' });
  const modals = useModalsStore();

  const [loading, setLoading] = useState(false);

  const onAgain = async () => {
    setLoading(true);
    const mediaStream = await getUserMedia();

    if (!mediaStream) {
      modals.closeModal();
      modals.openModal({
        type: 'AccessErrorModal',
      });
      return;
    }

    mediaStream.getTracks().forEach((item) => item.stop());
    modals.closeModal();
    setLoading(false);
  };

  return (
    <ModalContainerV2 pinBottom title={t('title')}>
      <Container>
        <Content>
          <div>
            <b>{t('chrome')} </b>
            <span>{t('chromeText')}</span>
          </div>
          <div>
            <b>{t('safari')} </b>
            <span>{t('safariText')}</span>
          </div>
          <div>
            <b>{t('firefox')} </b>
            <span>{t('firefoxText')}</span>
          </div>
        </Content>
        <Buttons>
          <ButtonIwText
            onClick={() => {
              modals.closeModal();
            }}
          >
            {t('closeBtn')}
          </ButtonIwText>
          <ButtonIw disabled={loading} loading={loading} onClick={onAgain}>
            {t('againBtn')}
          </ButtonIw>
        </Buttons>
      </Container>
    </ModalContainerV2>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  gap: 16px;
  width: 100%;
  padding: 24px 0;
`;

const Buttons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
  width: 100%;

  ${media.iwMobile} {
    flex-direction: column-reverse;
    margin-top: 16px;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
`;
